// require('./init-env');
const HttpApi = require('i18next-http-backend/cjs');

if (!process.env.NEXT_PUBLIC_LANG) {
  throw new Error('Please specify NEXT_PUBLIC_LANG to build for in NEXT_PUBLIC_LANG .env variable');
}

const isBrowser = typeof window !== 'undefined';
// On Vercel there is no localhost memcache process at runtime, and
// public/ assets are not part of the serverless function bundle (no
// amount of outputFileTracingIncludes coaxing we tried got them in
// the right /var/task/app-src/public/locales/<lng>/ shape). Use an
// inline backend that require()s the JSON -- webpack statically
// analyses the dynamic require, inlines every matching JSON into the
// function output, and resolves it from the bundled module at runtime
// with no filesystem access.
const isVercel = !!process.env.VERCEL;

function BundledBackend() {}
BundledBackend.type = 'backend';
BundledBackend.prototype.init = function init() {};
BundledBackend.prototype.read = function read(lng, ns, callback) {
  try {
    // eslint-disable-next-line global-require, import/no-dynamic-require
    const data = require(`./public/locales/${lng}/${ns}.json`);
    callback(null, data);
  } catch (e) {
    // Some namespaces don't exist for every locale (e.g. en/seo.json).
    // Returning an empty bundle lets the default-locale fallback kick in.
    callback(null, {});
  }
};

const serverBackendConfig = isVercel ? undefined : {
  // expirationTime: 5 * 1000, // 5 seconds
  // reloadInterval: 5 * 1000, // 5 seconds
  reloadInterval: 30 * 60 * 1000, // 30 mins
  loadPath: `http://localhost:${process.env.NEXT_PUBLIC_MEMCACHE_PORT}/translations/{{ns}}`,
  addPath: '',
};

const serverBackendModule = isVercel ? BundledBackend : HttpApi;

module.exports = {
  react: {
    useSuspense: false,
  },
  i18n: {
    defaultLocale: 'en',
    locales: ['en', process.env.NEXT_PUBLIC_LANG],
    backend: !isBrowser ? serverBackendConfig : undefined,
  },
  debug: false,
  ns: ['common', 'unit', 'seo'],
  interpolation: {
    skipOnVariables: false,
    escapeValue: false,
  },
  serializeConfig: false,
  use: isBrowser ? [] : [serverBackendModule],
};
